/**
 * VenueOS Analytics Message Protocol
 *
 * Defines analytics-specific message types for postMessage communication.
 * These are separate from the main SDK messages to keep analytics internal.
 */
/**
 * Analytics message type constants
 */
export const ANALYTICS_MESSAGE_TYPES = {
    /** Request a Snowflake JWT token */
    TOKEN_REQUEST: 'VENUEOS_ANALYTICS_TOKEN_REQUEST',
    /** Response with Snowflake token */
    TOKEN_RESPONSE: 'VENUEOS_ANALYTICS_TOKEN_RESPONSE',
};
/**
 * Analytics protocol version
 */
export const ANALYTICS_PROTOCOL_VERSION = '1.0.0';
/**
 * Type guard to check if a message is an analytics message
 */
export function isAnalyticsMessage(data) {
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    const message = data;
    return (typeof message.type === 'string' &&
        Object.values(ANALYTICS_MESSAGE_TYPES).includes(message.type) &&
        typeof message.version === 'string');
}
/**
 * Type guard for token request messages
 */
export function isAnalyticsTokenRequestMessage(message) {
    return message.type === ANALYTICS_MESSAGE_TYPES.TOKEN_REQUEST;
}
/**
 * Type guard for token response messages
 */
export function isAnalyticsTokenResponseMessage(message) {
    return message.type === ANALYTICS_MESSAGE_TYPES.TOKEN_RESPONSE;
}
/**
 * Create a token request message
 */
export function createTokenRequestMessage(requestId) {
    return {
        type: ANALYTICS_MESSAGE_TYPES.TOKEN_REQUEST,
        version: ANALYTICS_PROTOCOL_VERSION,
        requestId,
    };
}
/**
 * Create a token response message
 */
export function createTokenResponseMessage(requestId, credentials, error) {
    return {
        type: ANALYTICS_MESSAGE_TYPES.TOKEN_RESPONSE,
        version: ANALYTICS_PROTOCOL_VERSION,
        requestId,
        success: !error && !!credentials,
        credentials,
        error,
    };
}
